import { cn } from '@/lib/utils'

// Three small circles that gather and part while something loads (styles/motion.css). It waits a moment before it
// shows, so a quick load never flashes it. `now` shows it straight away, for a wait that's already known to be long.
export function Loader({
  label = 'Loading',
  size = 'md',
  tone,
  now,
  className,
}: {
  label?: string
  size?: 'sm' | 'md' | 'lg'
  // "quiet" draws the circles in the text's colour, for the dark viewer or inside a button.
  tone?: 'quiet'
  now?: boolean
  className?: string
}) {
  return (
    <span
      role="status"
      aria-label={label}
      data-size={size}
      data-tone={tone}
      data-now={now ? '' : undefined}
      className={cn('gather', className)}
    >
      <span />
      <span />
      <span />
    </span>
  )
}

// A page that's still arriving: the circles in the middle of where it will be, so the page never sits blank.
export function PageLoader({ label, className }: { label?: string; className?: string }) {
  return (
    <div className={cn('grid min-h-[50svh] flex-1 place-items-center', className)}>
      <Loader label={label} />
    </div>
  )
}

// A full-screen page (the photo viewer, a storybook, a print builder) that's still arriving, on its own surface.
export function ScreenLoader({ surface, label }: { surface: 'viewer' | 'table'; label?: string }) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-50 grid place-items-center',
        surface === 'viewer' ? 'bg-viewer text-viewer-foreground' : 'bg-table text-table-foreground',
      )}
    >
      <Loader label={label} tone={surface === 'viewer' ? 'quiet' : undefined} />
    </div>
  )
}
